import { Injectable } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import { ToastController, NavOptions } from 'ionic-angular';
import { NavController } from 'ionic-angular';
import { HomePage } from '../pages/home/home';
import { ModelParameters } from '../providers/model-parameters';
import { UserInstanceData } from '../providers/user-instance-data';
import { WeatherData } from '../providers/weather-data';
import { LrxMap } from '../providers/lrx-map';

export interface ItemsResponse {
  results: string[];
}



@Injectable()
export class ServerService {

  results: string[];
  userInstanceData:UserInstanceData;
  public modelRunning:boolean;
  //private url = "https://jz457w6dui.execute-api.us-west-2.amazonaws.com/LRxAloha?chemical_name=BUTANE"
  //private url = "http://google.com"
  
  //private instanceId = "i-001b0fa9adc70de63";


  constructor(private http: HttpClient,private toastCtrl: ToastController) {}

  turnOnServer(instanceId){
    let url = "https://47jhr6ur6k.execute-api.us-west-2.amazonaws.com/prod";
    let start_stop = "1";
    //let queryParams = new HttpParams().set('start_stop', start_stop).set("instanceId",this.instanceId);
    let queryParams = new HttpParams().set('start_stop', start_stop).set("instanceId",instanceId);
    //this.http.get(url,{params:queryParams,
    //    headers: new HttpHeaders().set('Authorization', this.getAccessHeader())})
    this.http.get(url,{params:queryParams})
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      this.results = data['StartingInstances'];
      /*let toast = this.toastCtrl.create({
        message: 'Starting Service!',
        duration: 3000,
        position: 'top'
      });
    
      toast.onDidDismiss(() => {
        console.log('Dismissed toast');
      });    
      toast.present();*/
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );
  }

  turnOffServer(instanceId){
    /*let url = "https://47jhr6ur6k.execute-api.us-west-2.amazonaws.com/prod";
    let start_stop = "0";
    let queryParams = new HttpParams().set('start_stop', start_stop).set("instanceId",instanceId);
    //this.http.get(url,{params:queryParams,
    //    headers: new HttpHeaders().set('Authorization', this.getAccessHeader())}
   // )
    this.http.get(url,{params:queryParams}
    )
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      this.results = data['StoppingInstances'];
      
      },
      /*let toast = this.toastCtrl.create({
        message: 'Stopping Service!',
        duration: 3000,
        position: 'top'
      });
    
      toast.onDidDismiss(() => {
        console.log('Dismissed toast');
      });    
      toast.present();
      },*/
      /*(err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    );*/
    console.log("in turn off!");
  }

  runNewModel(userInstance:UserInstanceData, runParams:ModelParameters,navCtrl:NavController, incidentName:string, CallBack){

    //TODO uncomment for prod
    this.turnOnServer(this.userInstanceData.InstanceId);
    runParams.latitude = runParams.latitude.toString();
    runParams.longitude = runParams.longitude.toString();

    let runModelBody = {
      "queue_url": "https://sqs.us-west-2.amazonaws.com/971076213821/LRX-"+this.userInstanceData.AccountId,
      "message": {
        "IncidentName": incidentName,
        "run_model": "true",
        "ModelParameters": runParams,
        "UserInstanceData": userInstance}
    }
    /*
    let runModelBody = {
      "queue_url": "https://sqs.us-west-2.amazonaws.com/971076213821/LRX-"+this.userInstanceData.UserName,
      "message": {
        "IncidentName": incidentName,
        "run_model": "true",
        "ModelParameters": runParams,
        "UserInstanceData": userInstance}
    }
    */
    let url = "https://j1o5457fx0.execute-api.us-west-2.amazonaws.com/prod";
    //this.http.post(url,runModelBody,
    //    {headers: new HttpHeaders().set('Authorization', this.getAccessHeader())}
    //)
    this.http.post(url,runModelBody
    )
    .subscribe(
      data => {
        this.results = data["body"];
        let toast = this.toastCtrl.create({
            message: 'Model Running!',
            duration: 120000,
            position: 'top'
          });
        
          toast.onDidDismiss(() => {
            //this.modelRunning = true;
            this.SetModelRunning();
            console.log('Dismissed Model Running toast');
            //navCtrl.pop();        
          });    
          toast.present();
          this.modelRunning = false;
          
          //let popPromise = navCtrl.pop();
          //popPromise.then(this.CheckIfRunning);
          CallBack(runParams).then(()=>{
            let popPromise = navCtrl.pop();
            popPromise.then(this.CheckIfRunning);
         });
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }
      }
    )
  }

  SetModelRunning(){
    this.modelRunning = true;
  }

  CheckIfRunning= () =>{
    setTimeout(() => {
      this.RestartServer();
    }, 90000);
  }

  RestartServer(){
    if(this.modelRunning === false){
      //this.turnOffServer(this.userInstanceData.InstanceId);
      setTimeout(() => {
        console.log('modelrunning false!');
        //this.turnOnServer(this.userInstanceData.InstanceId);
        
      }, 16000);
      
    }
  }

  GetAccountData(CallBack){
    let url = "https://qa0dmykjbb.execute-api.us-west-2.amazonaws.com/Prod";
    //let url = "https://qa0dmykjbb.execute-api.us-west-2.amazonaws.com/test";
    let emptylBody = {
      "Empty": "Empty"
    }
    //this.http.get(url)
    this.http.post(url,emptylBody)
    .subscribe(
      data => {
      CallBack(data['Items'][0]);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } 
        else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }      
      }
      );
    }

  GetUserLocationData(CallBack){
    let url = "https://dfj8tl59q6.execute-api.us-west-2.amazonaws.com/Prod/";
    //let queryParams = new HttpParams().set('UserName', userName);
    this.http.get(url)
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      //this.userInstanceData = data['Items'][0];
      /*let toast = this.toastCtrl.create({
        message: 'Model Running Test CSS!',
        duration: 230000,
        position: 'top',
        cssClass: "my-Toast-Height"
      });
      toast.present();*/
      CallBack(data['Items']);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } 
        else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }      
      }
      );
    }

  GetUserInstanceData(userName:string,CallBack){
  let url = "https://8a98q9e9fj.execute-api.us-west-2.amazonaws.com/Prod/RunData";
  let queryParams = new HttpParams().set('UserName', userName);
  this.http.get(url,{params:queryParams})
  .subscribe(
    data => {
    // Read the result field from the JSON response.
    this.userInstanceData = data['Items'][0];
    /*let toast = this.toastCtrl.create({
      message: 'Model Running Test CSS!',
      duration: 230000,
      position: 'top',
      cssClass: "my-Toast-Height"
    });
    toast.present();*/
    CallBack();
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        console.log('An error occurred:', err.error.message);
      } 
      else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
      }      
    }
    );
  }

  GetTier2Data(StateCode:string,lat:string,lon:string,CallBack){
    let url = "https://7s07y3frzd.execute-api.us-west-2.amazonaws.com/Prod";
    let runModelBody = {
        "StateCode": StateCode,
        "lat": lat,
        "lon": lon
      };
    
    this.http.post(url,runModelBody)
      .subscribe(
      data => {
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } 
        else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }      
      }
      );
    }

  GetWeatherData(AccountId:string,CallBack, Date:string=null){
    let url = "https://73hpdtotb3.execute-api.us-west-2.amazonaws.com/prod/";
    let queryParams = new HttpParams().set('AccountId', AccountId);
    if(Date !== null){
      queryParams = new HttpParams().set('AccountId', AccountId).set('Date',Date);
    }
    this.http.get(url,{params:queryParams})
    .subscribe(
      data => {
      // Read the result field from the JSON response.
      // data['Items'][0];
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } 
        else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }      
      }
      );
   }

  GetIncidents(CallBack, lastKey:string=null){
  let url = "https://qvhrhblfzd.execute-api.us-west-2.amazonaws.com/Prod";
  let runModelBody = {}
  if(lastKey){
    runModelBody = {
      "lastKey": lastKey
    }
  }
  this.http.post(url,runModelBody)
    .subscribe(
    data => {
    // Read the result field from the JSON response.
    //this.userInstanceData = data['Items'][0];
    /*let toast = this.toastCtrl.create({
      message: 'Model Running Test CSS!',
      duration: 230000,
      position: 'top',
      cssClass: "my-Toast-Height"
    });
    toast.present();*/
    CallBack(data);
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        console.log('An error occurred:', err.error.message);
      } 
      else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
      }      
    }
    );
  }

  GetIncidentModels(incidentName:string, CallBack, lastKey:string=null){
  let url = "https://1rci8hogt4.execute-api.us-west-2.amazonaws.com/Prod";
  let runModelBody = {
    "IncidentName":incidentName,
    "lastKey": ""
  }
  if(lastKey){
    runModelBody = {
      "IncidentName":incidentName,
      "lastKey": lastKey
    }
  }
  this.http.post(url,runModelBody)
    .subscribe(
    data => {
    // Read the result field from the JSON response.
    //this.userInstanceData = data['Items'][0];
    /*let toast = this.toastCtrl.create({
      message: 'Model Running Test CSS!',
      duration: 230000,
      position: 'top',
      cssClass: "my-Toast-Height"
    });
    toast.present();*/
    CallBack(data);
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        // A client-side or network error occurred. Handle it accordingly.
        console.log('An error occurred:', err.error.message);
      } 
      else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
      }      
    }
    );
  }

  UpdateBaseMap(baseMap:LrxMap, CallBack){
    let url = "https://6aktvtx1l5.execute-api.us-west-2.amazonaws.com/Prod";

    baseMap.prepForSave();
    
    this.http.post(url,baseMap)
      .subscribe(
      data => {
      CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } 
        else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }      
      }
      );
    }

  //SetIot(id:string, CallBack){
  SetIot(id:string){
      let url = "https://vqzhuwps14.execute-api.us-west-2.amazonaws.com/Prod";
    let runModelBody = {
      "id":id
    }
    this.http.post(url,runModelBody)
      .subscribe(
      data => {
      //CallBack(data);
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          // A client-side or network error occurred. Handle it accordingly.
          console.log('An error occurred:', err.error.message);
        } 
        else {
          // The backend returned an unsuccessful response code.
          // The response body may contain clues as to what went wrong,
          console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
        }      
      }
      );
    }
}



// WEBPACK FOOTER //
// ./src/service/server.service.ts